import React from "react";
import logger from "logger";
import Dialog from "@material-ui/core/Dialog";
import { showDialog } from "DialogProvider";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

export default function(props) {
  const { fullScreen } = props;

  const closeDialog = () => {
    showDialog(null);
  };

  const contentStyle = {
    padding: "20px",
    margin: "0 auto",
    width: "-webkit-fill-available",
    minWidth: "250px",
  };

  const headingStyle = { padding: "30px", display: "flex" };

  if (fullScreen) {
    contentStyle.textAlign = "left";
    contentStyle.paddingTop = "120px";
    headingStyle.position = "fixed";
    headingStyle.width = "-webkit-fill-available";
  }

  if (!fullScreen) {
    contentStyle.maxWidth = "400px";
  }

  return (
    <Dialog onClose={closeDialog} open={true} fullScreen={fullScreen}>
      <div
        className={`heading ${fullScreen ? "fullWidth" : ""}`}
        style={headingStyle}
      >
        <h2 style={{ display: "inline", margin: "0px" }}>{props.heading}</h2>
        <span style={{ flex: "auto" }} />
        <CloseOutlinedIcon
          onClick={closeDialog}
          className="enlargeonhover"
          style={{ color: "white", display: "inline", margin: "auto auto" }}
        />
      </div>
      <div align="center" className="komform" style={contentStyle}>
        {props.children}
      </div>
    </Dialog>
  );
}
